import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Navigation from '../components/Navigation';
import AdvancedAnalysis from '../components/AdvancedAnalysis';
// TODO: Make sure these import paths match your actual component names!
import CompetitorAnalysis from '../components/CompetitorAnalysis'; 
import TrendingAnalysis from '../components/TrendingAnalysis';
import '../styles/ToolPage.css';

export default function ToolPage({ user, onLogout }) {
  const location = useLocation();

  const handleUpdateCredits = (newBalance) => {
    const updatedUser = { ...user, credits: newBalance };
    localStorage.setItem('user', JSON.stringify(updatedUser));
  };

  // Determine which nav item should be highlighted based on URL
  const getCurrentPage = () => {
    if (location.pathname.includes('/competitor')) return 'competitor';
    if (location.pathname.includes('/trending')) return 'trending';
    return 'analysis'; // Default to homepage
  };

  return (
    <div className="tool-page">
      {/* Header */}
      <header className="tool-header">
        <div className="header-left">
          <a href="https://contentserp.in/dashboard" className="back-link">
            ← Dashboard पर वापस जाएं
          </a>
          <div className="header-title">
            <h1>🎬 YouTube Content Analyzer</h1>
            <p className="tagline">भारतीय YouTubers के लिए AI-powered Content Strategy</p>
          </div>
        </div>

        <div className="header-right">
          <div className="user-badge">
            <div className="user-details">
              <span className="user-email">{user?.email}</span>
              <span className="user-name">👤 {user?.name || 'User'}</span>
            </div>
            <div className="credit-badge">
              <span className="credit-icon">💳</span>
              <span className="credit-value">{user?.credits || 0}</span>
            </div>
          </div>
          <button onClick={onLogout} className="logout-btn">
            लॉगआउट
          </button>
        </div>
      </header>

      {/* Navigation Menu */}
      <Navigation currentPage={getCurrentPage()} />

      {/* Main Content - Now handled by React Router dynamically! */}
      <main className="tool-content">
        <Routes>
          {/* Default page (Advance Analysis) */}
          <Route 
            path="/" 
            element={<AdvancedAnalysis user={user} onCreditsUpdate={handleUpdateCredits} />} 
          />
          
          {/* Competitor page */}
          <Route 
            path="/pages/competitor" 
            element={<CompetitorAnalysis user={user} onCreditsUpdate={handleUpdateCredits} />} 
          />
          
          {/* Trending page */}
          <Route 
            path="/pages/trending" 
            element={<TrendingAnalysis user={user} onCreditsUpdate={handleUpdateCredits} />} 
          />
        </Routes>
      </main>

      {/* Footer (Remains unchanged) */}
      <footer className="tool-footer">
        {/* ... (keep your existing footer content exactly the same) ... */}
        <div className="footer-bottom">
          <p>© 2025 <strong>ContentSERP</strong> - भारतीय Content Creators के लिए सर्वश्रेष्ठ AI Tool</p>
          <p>
            <a href="https://contentserp.in/dashboard">Dashboard</a> |
            <a href="https://contentserp.in/support">Support</a> |
            <a href="https://contentserp.in/blog">Blog</a>
          </p>
        </div>
      </footer>
    </div>
  );
}

